import { render } from "./HomePage.vue?vue&type=template&id=df1f9672"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"
script.render = render

export default script